<template>
  <v-tabs v-model="activeTab" slider-color="grey darken-1" show-arrows>
    <slot :board-item="boardItem">
      <v-tab ripple>
        <v-icon small class="mr-2">{{ $vuetify.icons.values.comment }}</v-icon>
        {{ $t('labels.comments') }}
      </v-tab>
      <v-tab-item>
        <Comments :board-item="boardItem" :key="`comments-${boardItem.entity.id}`" />
      </v-tab-item>

      <v-tab ripple>
        <v-icon small class="mr-2">{{ $vuetify.icons.values.todo }}</v-icon>
        {{ $t('labels.todos') }}
      </v-tab>
      <v-tab-item class="mt-4">
        <Todos :board-item="boardItem" :key="`todos-${boardItem.entity.id}`" enable-owner />
      </v-tab-item>

      <v-tab ripple>
        <v-icon small class="mr-2">{{ $vuetify.icons.values.reminder }}</v-icon>
        {{ $t('labels.reminders') }}
      </v-tab>
      <v-tab-item class="mt-4">
        <Reminders :board-item="boardItem" :key="`reminders-${boardItem.entity.id}`" enable-owner />
      </v-tab-item>

      <v-tab ripple>
        <v-icon small class="mr-2">{{ $vuetify.icons.values.reminder }}</v-icon>
        {{ $t('labels.tasks') }}
      </v-tab>
      <v-tab-item class="mt-4">
        <Tasks :board-item="boardItem" :key="`tasks-${boardItem.entity.id}`" enable-owner />
      </v-tab-item>

      <v-tab ripple>
        <v-icon small class="mr-2">{{ $vuetify.icons.values.file }}</v-icon>
        {{ $t('labels.documents') }}
      </v-tab>
      <v-tab-item class="mt-4">
        <Documents :board-item="boardItem" :key="`documents-${boardItem.entity.id}`" enable-owner />
      </v-tab-item>

      <v-tab ripple>
        <v-icon small class="mr-2">{{ $vuetify.icons.values.transition }}</v-icon>
        {{ $t('labels.transitions') }}
        <span v-if="hasTransitionWarning">
          <v-icon small class="ml-2" v-if="hasTransitionWarning">{{ $vuetify.icons.values.warning }}</v-icon>
        </span>
      </v-tab>
      <v-tab-item class="mt-4">
        <flow-log />
      </v-tab-item>
    </slot>
  </v-tabs>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { NAMESPACE as ME_NAMESPACE } from '@argon/iam/me/store'
import { Todos, Reminders, Comments, Tasks, Documents } from '@argon/evo/addons/components'

import { NAMESPACE } from '../store'
import FlowLog from './FlowLog'
import entityPerimeter from '../perimeters'

export default {
  name: 'EntityTabs',
  components: {
    Todos,
    Tasks,
    Reminders,
    Comments,
    Documents,
    FlowLog
  },
  perimeters: [entityPerimeter],
  props: {
    // boardItem: { type: Object, required: true }
  },
  data: () => ({
    activeTab: null
  }),
  computed: {
    ...mapState(NAMESPACE, ['boardItem']),
    ...mapGetters(ME_NAMESPACE, ['timezone']),
    hasTransitionWarning() {
      return this.boardItem.report.transition
        ? this.boardItem.report.transitions.some((item) => item.status !== 'DONE')
        : false
    }
  }
}
</script>

<style scoped lang="scss">
// ::v-deep .v-tabs__content {
// min-height: 450px;
// }
::v-deep .v-tabs {
  .v-tabs-bar {
    border-bottom-style: solid;
    border-bottom-color: var(--v-grey-base);
    border-bottom-width: 1px;
  }

  .v-tab--active {
    font-size: bolder !important;
  }
}
</style>
